//Import Mixpanel SDK
import mixpanel from "mixpanel-browser"
import { config } from "~/lib/config"

export const initMixPanel = () => {
  mixpanel.init(config.env.mixpanelToken, {
    debug: config.env.isDevelopment,
    autocapture: true,
    track_pageview: true,
    persistence: "localStorage",
    record_heatmap_data: true,
    record_sessions_percent: 100, // we got 20k a month we don't have close to that many users yet
  })
}
